import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export type PlanDocument = {
  documentTitle: string;
  documentLanguage: {
    targetId: string;
    tagetItem: DocumentLanguage;
  };

  documentLink: LinkField;
  updatedDate: Date;
};

export type DocumentLanguage = {
  id: string;
  value: string;
  languageAttribute: string;
  lastUpdatedDateLabel: string;
};
